import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const delayStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("DELAY"),
  step_data: z.object({
    advance_same_day: z.boolean().nullable(),
    delay_as_minimum_duration: z.boolean().nullable(),
    delay_in_seconds: z.int().nullable(),
    delay_until: common.unixTimestamp.nullable(),
    delay_until_iso: common.dateTimeNoOffset.nullable(),
    delay_until_next_day: z
      .enum(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"])
      .nullable(),
    delay_until_variable: z.string().nullable(),
    delay_until_variable_type: z
      .enum(["custom_attribute", "context", "context_properties", "canvas_properties"])
      .nullable(),
    duration_variable: z.string().nullable(),
    duration_variable_type: z
      .enum(["context", "custom_attribute", "context_properties", "canvas_properties"])
      .nullable(),
    duration_variable_unit: z.enum(["seconds", "minutes", "hours", "days", "calendar_days"]).nullable(),
    in_local_time: z.boolean().nullable(),
    specific_time: z.int().nullable(),
  }),
});
